import React, {useEffect, useState} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";

const SignupRedirectNew = () => {
    const [loading, setLoading] = useState(true);
    const [result, setResult] = useState(null);
    const { loginWithRedirect } = useAuth0();
    const location = useLocation();
    const [token, setToken] = useState("");



    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setToken(params.get("token"));
        console.log(token)
        if (token) setToken(token);


        fetch(`http://localhost:8080/activate/prepare/big?token=${token}`)
            .then(res => res.json())
            .then(data => {
                setLoading(false);

                sessionStorage.setItem("firstName", data.firstName);
                sessionStorage.setItem("lastName", data.lastName);
                const redirectPath = `/activateNew?token=${token}`;

                loginWithRedirect({
                    authorizationParams: {
                        screen_hint: 'signup',
                        redirect_uri: `${window.location.origin}${redirectPath}`,
                        login_hint: data.email || "",
                    },
                    appState: {returnTo: redirectPath},
                }).then(r =>{
                    console.log("Redirecting to signup with token:", token);
                });
            })
            .catch((error) => {
                console.log("error", error);
                setResult({ error: error });
                setLoading(false);
            });



    }, [loginWithRedirect, location.search, token]);

    if (loading) return <div>Loading the Sign Up form...</div>;
    // if (result?.error) return <div>{result.error}</div>;
    if (result?.error) {
        return <div dangerouslySetInnerHTML={{ __html: result.error }} />;
    }

    return null;
};



export default SignupRedirectNew;